import type { CandidateTest } from '@/types'

/**
 * Tailwind classes for a candidate-test priority badge (P0–P3), shared so the
 * Application-page Candidates tab (`CandidatesSection`) and the discovery
 * dialog's `CandidatePickerPanel` render priority identically (#1452). Higher
 * bands read "hotter" so the eye lands on P0/P1 first; the list arrives
 * priority-ordered from the server (#1440), so this is purely visual.
 *
 * Extracted from `CandidatesSection.tsx` when the picker became a second
 * consumer — one map, no copy-paste.
 */
export const PRIORITY_BADGE: Record<NonNullable<CandidateTest['priority']>, string> = {
  P0: 'bg-red-500/10 text-red-500 border-red-500/30',
  P1: 'bg-amber-500/10 text-amber-500 border-amber-500/30',
  P2: 'bg-sky-500/10 text-sky-500 border-sky-500/30',
  P3: 'bg-slate-500/10 text-slate-500 border-slate-500/30',
}
